import { jsxs as W, jsx as c } from "react/jsx-runtime";
import { getStylesFromSelectors as G, createPureSelectors as D, createClassNameSelectors as J } from "../../utils/classNameSelectors.js";
import "../../utils/sectionPreview.js";
import { forwardRef as K } from "react";
import f from "clsx";
import Q from "next/link";
import { getButtonIcon as X } from "./constants.js";
import '../../_assets/Button.0PXsgWwA.css';const Y = "_btn_nc8vo_44", Z = "_disabled_nc8vo_67", E = "_reverse_nc8vo_90", I = "_icon_nc8vo_101", M = "_link_nc8vo_111", H = "_linkGray_nc8vo_111", nn = "_linkTerminal_nc8vo_111", _n = "_noPadding_nc8vo_114", ln = "_link_new_nc8vo_1855", on = "_linkGray_new_nc8vo_1856", mn = "_linkTerminal_new_nc8vo_1857", en = "_primary_new_nc8vo_2525", cn = "_primaryV2_new_nc8vo_2541", an = "_secondary_new_nc8vo_2555", tn = "_tertiary_new_nc8vo_2569", sn = "_goGreen_new_nc8vo_2589", rn = "_border_new_nc8vo_2605", wn = "_outline_new_nc8vo_2629", xn = "_outlineGray_new_nc8vo_2653", vn = "_outlineWhite_new_nc8vo_2677", hn = "_linkWhite_new_nc8vo_2738", un = "_white_new_nc8vo_2748", dn = "_terminal_new_nc8vo_2762", gn = "_outlineTerminal_new_nc8vo_2776", Sn = "_outlineWhiteBorder_new_nc8vo_2811", yn = "_outlineGrey_new_nc8vo_2829", pn = "_fuchsia_new_nc8vo_2853", kn = "_agzPrimary_new_nc8vo_2868", bn = "_agzWhite_new_nc8vo_2881", Wn = "_fluid_nc8vo_2918", Gn = "_rounded_nc8vo_2922", fn = "_noWrap_nc8vo_2926", n = {
  btn: Y,
  disabled: Z,
  reverse: E,
  "xxs-large": "_xxs-large_nc8vo_95",
  icon: I,
  "icon-left": "_icon-left_nc8vo_105",
  "icon-right": "_icon-right_nc8vo_108",
  link: M,
  linkGray: H,
  linkTerminal: nn,
  noPadding: _n,
  "with-icon-xxs-large": "_with-icon-xxs-large_nc8vo_118",
  "xxs-medium": "_xxs-medium_nc8vo_138",
  "with-icon-xxs-medium": "_with-icon-xxs-medium_nc8vo_161",
  "xxs-small": "_xxs-small_nc8vo_181",
  "with-icon-xxs-small": "_with-icon-xxs-small_nc8vo_204",
  "xxs-xSmall": "_xxs-xSmall_nc8vo_224",
  "with-icon-xxs-xSmall": "_with-icon-xxs-xSmall_nc8vo_247",
  "xs-large": "_xs-large_nc8vo_271",
  "with-icon-xs-large": "_with-icon-xs-large_nc8vo_294",
  "xs-medium": "_xs-medium_nc8vo_314",
  "with-icon-xs-medium": "_with-icon-xs-medium_nc8vo_337",
  "xs-small": "_xs-small_nc8vo_357",
  "with-icon-xs-small": "_with-icon-xs-small_nc8vo_380",
  "xs-xSmall": "_xs-xSmall_nc8vo_400",
  "with-icon-xs-xSmall": "_with-icon-xs-xSmall_nc8vo_423",
  "s-large": "_s-large_nc8vo_447",
  "with-icon-s-large": "_with-icon-s-large_nc8vo_470",
  "s-medium": "_s-medium_nc8vo_490",
  "with-icon-s-medium": "_with-icon-s-medium_nc8vo_513",
  "s-small": "_s-small_nc8vo_533",
  "with-icon-s-small": "_with-icon-s-small_nc8vo_556",
  "s-xSmall": "_s-xSmall_nc8vo_576",
  "with-icon-s-xSmall": "_with-icon-s-xSmall_nc8vo_599",
  "ssm-large": "_ssm-large_nc8vo_623",
  "with-icon-ssm-large": "_with-icon-ssm-large_nc8vo_646",
  "ssm-medium": "_ssm-medium_nc8vo_666",
  "with-icon-ssm-medium": "_with-icon-ssm-medium_nc8vo_689",
  "ssm-small": "_ssm-small_nc8vo_709",
  "with-icon-ssm-small": "_with-icon-ssm-small_nc8vo_732",
  "ssm-xSmall": "_ssm-xSmall_nc8vo_752",
  "with-icon-ssm-xSmall": "_with-icon-ssm-xSmall_nc8vo_775",
  "sm-large": "_sm-large_nc8vo_799",
  "with-icon-sm-large": "_with-icon-sm-large_nc8vo_822",
  "sm-medium": "_sm-medium_nc8vo_842",
  "with-icon-sm-medium": "_with-icon-sm-medium_nc8vo_865",
  "sm-small": "_sm-small_nc8vo_885",
  "with-icon-sm-small": "_with-icon-sm-small_nc8vo_908",
  "sm-xSmall": "_sm-xSmall_nc8vo_928",
  "with-icon-sm-xSmall": "_with-icon-sm-xSmall_nc8vo_951",
  "m-large": "_m-large_nc8vo_975",
  "with-icon-m-large": "_with-icon-m-large_nc8vo_998",
  "m-medium": "_m-medium_nc8vo_1018",
  "with-icon-m-medium": "_with-icon-m-medium_nc8vo_1041",
  "m-small": "_m-small_nc8vo_1061",
  "with-icon-m-small": "_with-icon-m-small_nc8vo_1084",
  "m-xSmall": "_m-xSmall_nc8vo_1104",
  "with-icon-m-xSmall": "_with-icon-m-xSmall_nc8vo_1127",
  "xm-large": "_xm-large_nc8vo_1151",
  "with-icon-xm-large": "_with-icon-xm-large_nc8vo_1174",
  "xm-medium": "_xm-medium_nc8vo_1194",
  "with-icon-xm-medium": "_with-icon-xm-medium_nc8vo_1217",
  "xm-small": "_xm-small_nc8vo_1237",
  "with-icon-xm-small": "_with-icon-xm-small_nc8vo_1260",
  "xm-xSmall": "_xm-xSmall_nc8vo_1280",
  "with-icon-xm-xSmall": "_with-icon-xm-xSmall_nc8vo_1303",
  "l-large": "_l-large_nc8vo_1327",
  "with-icon-l-large": "_with-icon-l-large_nc8vo_1350",
  "l-medium": "_l-medium_nc8vo_1370",
  "with-icon-l-medium": "_with-icon-l-medium_nc8vo_1393",
  "l-small": "_l-small_nc8vo_1413",
  "with-icon-l-small": "_with-icon-l-small_nc8vo_1436",
  "l-xSmall": "_l-xSmall_nc8vo_1456",
  "with-icon-l-xSmall": "_with-icon-l-xSmall_nc8vo_1479",
  "xl-large": "_xl-large_nc8vo_1503",
  "with-icon-xl-large": "_with-icon-xl-large_nc8vo_1526",
  "xl-medium": "_xl-medium_nc8vo_1546",
  "with-icon-xl-medium": "_with-icon-xl-medium_nc8vo_1569",
  "xl-small": "_xl-small_nc8vo_1589",
  "with-icon-xl-small": "_with-icon-xl-small_nc8vo_1612",
  "xl-xSmall": "_xl-xSmall_nc8vo_1632",
  "with-icon-xl-xSmall": "_with-icon-xl-xSmall_nc8vo_1655",
  "xxl-large": "_xxl-large_nc8vo_1679",
  "with-icon-xxl-large": "_with-icon-xxl-large_nc8vo_1702",
  "xxl-medium": "_xxl-medium_nc8vo_1722",
  "with-icon-xxl-medium": "_with-icon-xxl-medium_nc8vo_1745",
  "xxl-small": "_xxl-small_nc8vo_1765",
  "with-icon-xxl-small": "_with-icon-xxl-small_nc8vo_1788",
  "xxl-xSmall": "_xxl-xSmall_nc8vo_1808",
  "with-icon-xxl-xSmall": "_with-icon-xxl-xSmall_nc8vo_1831",
  link_new: ln,
  linkGray_new: on,
  linkTerminal_new: mn,
  primary_new: en,
  primaryV2_new: cn,
  secondary_new: an,
  tertiary_new: tn,
  goGreen_new: sn,
  border_new: rn,
  outline_new: wn,
  outlineGray_new: xn,
  outlineWhite_new: vn,
  linkWhite_new: hn,
  white_new: un,
  terminal_new: dn,
  outlineTerminal_new: gn,
  outlineWhiteBorder_new: Sn,
  outlineGrey_new: yn,
  fuchsia_new: pn,
  agzPrimary_new: kn,
  agzWhite_new: bn,
  fluid: Wn,
  rounded: Gn,
  noWrap: fn,
  "slide-in-out": "_slide-in-out_nc8vo_1",
  "fade-in-out": "_fade-in-out_nc8vo_1"
}, $n = [
  "primary",
  "primaryV2",
  "secondary",
  "tertiary",
  "goGreen",
  "outline",
  "border",
  "link",
  "outlineGray",
  "linkGray",
  "linkWhite",
  "white",
  "terminal",
  "outlineTerminal",
  "linkTerminal",
  "outlineWhite",
  "outlineWhiteBorder",
  "outlineGrey",
  "fuchsia",
  "agzPrimary",
  "agzWhite"
], Tn = K(
  ({
    className: T,
    style: s,
    iconClassName: N,
    component: r = "button",
    type: w = "button",
    variant: z = "primary",
    rounded: B = !1,
    size: x = "large",
    disabled: v,
    fluid: C = !1,
    icon: _,
    iconPosition: h = "left",
    onlyIcon: l = !1,
    onClick: V,
    href: a,
    children: m,
    externalHref: i,
    noWrap: O,
    noPadding: A,
    dataTestId: $,
    onTouchStart: j,
    onTouchEnd: L,
    onMouseEnter: u,
    onMouseLeave: d,
    ...o
  }, g) => {
    var k, b;
    const e = (k = a == null ? void 0 : a.toString()) == null ? void 0 : k.trim(), t = !!(e != null && e.length || (b = i == null ? void 0 : i.trim()) != null && b.length), P = t ? Q : r, R = G(D(x, "small"), n), F = G(
      J("with-icon", x, "small"),
      n
    ), S = f(
      T,
      n.btn,
      n[`${z}_new`],
      !l && R,
      l && F,
      C && n.fluid,
      B && n.rounded,
      v && n.disabled,
      // for Link
      {
        [n.reverse]: h === "right"
      },
      O && n.noWrap,
      A && n.noPadding
    ), y = f(
      n.icon,
      {
        [n[`icon-${h}`]]: _ && !l
      },
      N
    ), U = w === "span", p = typeof _ == "string" ? X(_) : _, q = typeof m == "string" ? `${m} (Opens in a new tab)` : "Opens in a new tab";
    return U ? /* @__PURE__ */ W("span", { className: S, style: s, children: [
      _ && /* @__PURE__ */ c("span", { ref: g, className: y, ...o, children: p }),
      !l && /* @__PURE__ */ c("span", { children: m })
    ] }) : /* @__PURE__ */ W(
      P,
      {
        ref: g,
        type: !t && r === "button" ? w : null,
        href: e || i,
        className: S,
        disabled: v,
        target: i ? "_blank" : null,
        "aria-label": i || (o == null ? void 0 : o.target) === "_blank" ? q : null,
        onClick: V,
        "data-testid": $,
        ...u && { onMouseEnter: u },
        ...d && { onMouseLeave: d },
        ...!t && { onTouchStart: j, onTouchEnd: L },
        ...o,
        style: s,
        children: [
          _ && /* @__PURE__ */ c("span", { className: y, style: { position: "relative" }, children: p }),
          !l && /* @__PURE__ */ c("span", { children: m })
        ]
      }
    );
  }
);
Tn.displayName = "Button";
export {
  $n as BUTTON_VARIANTS,
  Tn as Button
};
